export const pageRoutes = {
  rootPath: '/',
  dashboard: '/dashboard',
  /** Dashboard scoped to a performance run (query params match backend run-scoped APIs). */
  dashboardProjectRun: (projectId: number, runId: number) =>
    `/dashboard?projectId=${projectId}&runId=${runId}`,
  health: '/health',
  onboarding: '/onboarding',
  onboardingUser: '/onboarding/user',
  onboardingProject: '/onboarding/project',
  onboardingEditUser: '/onboarding/edit-user',
  onboardingProjects: '/onboarding/projects',
  onboardingProjectById: (projectId: number) =>
    `/onboarding/projects/${projectId}`,
};
